/**
 * POPUP 型の CTA テキスト（右下サムネイルの上に出る吹き出し文言）に関する定数。
 * 埋め込み側（FloatingVideoThumbnail）と管理画面側（PopupEntrySettingsSection）で共有する。
 */

/** 未設定時に表示する既定文言 */
export const DEFAULT_POPUP_CTA_TEXT = '動画でご説明'

/** 表示崩れを防ぐための最大文字数 */
export const POPUP_CTA_TEXT_MAX_LENGTH = 40

/** POPUP 型の scenario.config に保持する設定 */
export type PopupConfig = {
  popupCtaText?: string
}
